const initialState = {
    headerPermissions:{},
    headerLists: [],
    headerStatus: [],
    changedHeaderStatus : [],
    loadingHeader: false,
    errorsHeader
: {}
}

const  headerReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_HEADERLIST_PENDING":
        case "ADD_HEADER_PENDING":
        case "UPDATE_HEADER_PENDING":
        case "UPDATE_HEADER_STATUS_PENDING":
        case "DELETE_HEADER_PENDING":
        case "GET_HEADERLISTBYID_PENDING":
            return { ...state, loadingGroup: true };

        case "GET_HEADERLIST_FULFILLED":
            return {
                ...state,
                loadingHeader: false,
                headerLists: action.payload,
                headerCount: action.headerCount,
                headerPermissions:action.permissions,
            };

        case "ADD_HEADER_FULFILLED":
            return {
                ...state,
                loadingHeader: false,
                changedHeaderStatus: action.payload,
            };

        case "UPDATE_HEADER_FULFILLED":
            return {
                ...state,
                loadingHeader: false,
                changedHeaderStatus: action.payload,
            };

        case "UPDATE_HEADER_STATUS_FULFILLED":
            return {
                ...state,
                loadingHeader: false,
                changedHeaderStatus: action.payload,
            };

        case "GET_HEADERLISTBYID_FULFILLED":
            return {
                ...state,
                loadingHeader: false,
                headerLists: action.payload
            };

        case "DELETE_HEADER_FULFILLED":
            return {
                ...state,
                loadingHeader: false,
                changedHeaderStatus: action.payload
            };

        case "RESET_DELETE_HEADER_STATUS":
            return {
                ...state,
                loadingHeader: false,
                changedHeaderStatus: [],
                errorsHeader
:{}
            };

        case "GET_HEADERLIST_REJECTED":
        case "ADD_HEADER_REJECTED":
        case "UPDATE_HEADER_REJECTED":
        case "UPDATE_HEADER_STATUS_REJECTED":
        case "DELETE_HEADER_REJECTED":
        case "GET_HEADERLISTBYID_REJECTED":
            return {
                ...state,
                loadingHeader: false,
                errorsHeader
: action.payload
            };

        default:
            return state;
    }
}

export default headerReducer;